import { memo } from 'react';
import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import PlusMinusButton from '../../../AddParticipant/PlusMinusButton';
import {
  SelectableLicense,
  createUnselectedLicense,
  createSelectedLicense,
  licenseHasValue,
} from '../Types';
import { LicensesReady } from '../Types';
import { AddLicenseToParticipantsStore } from '../Store';

interface Props {
  selectedLicense: SelectableLicense;
  index: number;
  isLastLicense: boolean;
  store: AddLicenseToParticipantsStore;
  state: LicensesReady;
}

function LicenseDropdown({ selectedLicense, index, isLastLicense, store, state }: Props) {
  const availableLicenses = store.getAvailableLicenses(selectedLicense);

  return (
    <div className="flex items-center gap-2 mb-2">
      <select
        data-intercom-target="bulk-license-assignment-license-select"
        className="flex-1 px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none appearance-none bg-white text-gray-400"
        style={{
          color: selectedLicense.kind === 'selected' ? '#111827' : '#4b5563',
        }}
        value={selectedLicense.kind === 'selected' ? selectedLicense.licenseId : ''}
        onChange={(e) => {
          if (e.target.value === '') {
            store.updateLicenseAtIndex(index, createUnselectedLicense());
            return;
          }
          const licenseId = parseInt(e.target.value);
          const license = state.resource.payload.allocatableOrReleasableLicenses.find(
            (l) => l.payload.id === licenseId,
          );
          if (license) {
            store.updateLicenseAtIndex(
              index,
              createSelectedLicense(licenseId, license.payload.name),
            );
          }
        }}
      >
        <option value="">
          <T kind="Select a license if needed..." />
        </option>
        {availableLicenses.map((license) => (
          <option key={license.payload.id} value={license.payload.id}>
            {license.payload.name}
          </option>
        ))}
      </select>
      {licenseHasValue(selectedLicense) && (
        <PlusMinusButton
          onClick={() => {
            store.removeLicenseAtIndex(index);
          }}
          which="minus"
          data-intercom-target="bulk-license-assignment-remove-license-button"
        />
      )}
      {isLastLicense && store.hasAvailableLicensesToAdd() && licenseHasValue(selectedLicense) && (
        <PlusMinusButton
          onClick={() => {
            store.addLicense();
          }}
          which="plus"
          data-intercom-target="bulk-license-assignment-add-license-button"
        />
      )}
    </div>
  );
}

export default memo(observer(LicenseDropdown));
